import React from "react";
import DashboardCustomizeIcon from "@mui/icons-material/DashboardCustomize";
import Widget from "../../widgets/Widget";
import { DASHBOARD_WIDGET_FONT_SIZE_FIELDS, WIDGET_PREVIEW_DATASTREAMS } from "./systemConfigurationUtils";

const DashboardWidgetsConfigPanel = ({
  dashboardWidgetFontSizes,
  selectedDashboardWidgetField,
  selectedDashboardWidgetTitle,
  selectedDashboardWidgetSize,
  selectedDashboardWidgetProps,
  setSelectedDashboardWidgetType,
  updateDashboardWidgetFontSize,
}) => (
  <section className="system-config-panel">
    <div className="system-config-panel-head">
      <div>
        <h3>Dashboard widget defaults</h3>
        <p>Set default typography and control spacing used when users add new web dashboard widgets.</p>
      </div>
    </div>

    <div className="system-config-widget-font-layout">
      <div className="system-config-widget-font-grid">
        {DASHBOARD_WIDGET_FONT_SIZE_FIELDS.map((field) => {
          const sizes = dashboardWidgetFontSizes.widgets?.[field.type] || field;
          const isSelected = selectedDashboardWidgetField?.type === field.type;
          return (
            <div
              className={`system-config-widget-font-row ${isSelected ? "selected" : ""}`}
              key={field.type}
              onClick={() => setSelectedDashboardWidgetType(field.type)}
            >
              <div className="system-config-widget-font-title">
                <DashboardCustomizeIcon />
                <span>
                  <strong>{field.label}</strong>
                  <small>{field.type}</small>
                </span>
              </div>
              <div className="system-config-widget-font-fields">
                {(field.fields || []).map((fontField) => {
                  const isDashField = fontField.key === "dash";
                  const isTitlePositionField = fontField.key === "titlePosition";
                  return (
                    <label key={`${field.type}-${fontField.key}`}>
                      <span>{fontField.label}</span>
                      {isTitlePositionField ? (
                        <select
                          value={sizes[fontField.key] ?? fontField.value}
                          onFocus={() => setSelectedDashboardWidgetType(field.type)}
                          onChange={(event) => updateDashboardWidgetFontSize(field.type, fontField.key, event.target.value)}
                        >
                          <option value="auto">Current (Default)</option>
                          <option value="left">Top Left</option>
                          <option value="center">Top Center</option>
                          <option value="right">Top Right</option>
                        </select>
                      ) : isDashField ? (
                        <select
                          value={sizes[fontField.key] ?? fontField.value}
                          onFocus={() => setSelectedDashboardWidgetType(field.type)}
                          onChange={(event) => updateDashboardWidgetFontSize(field.type, fontField.key, event.target.value)}
                        >
                          <option value="none">Solid</option>
                          <option value="dashed">Dashed</option>
                          <option value="dotted">Dotted</option>
                        </select>
                      ) : (
                        <input
                          type="number"
                          min={fontField.min ?? (fontField.key === "strokeWidth" ? "1" : "0")}
                          max={fontField.max ?? (fontField.key === "strokeWidth" ? "18" : fontField.key === "bend" ? "100" : "160")}
                          step="1"
                          value={sizes[fontField.key] ?? fontField.value}
                          onFocus={() => setSelectedDashboardWidgetType(field.type)}
                          onChange={(event) => updateDashboardWidgetFontSize(field.type, fontField.key, event.target.value)}
                        />
                      )}
                    </label>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>

      <aside className="system-config-widget-preview" aria-label={`${selectedDashboardWidgetTitle} preview`}>
        <div className="system-config-widget-preview-headline">
          <span>{selectedDashboardWidgetTitle}</span>
          <small>{selectedDashboardWidgetField?.type}</small>
        </div>
        <div className="system-config-widget-preview-stage">
          <Widget
            id={`system-config-preview-${selectedDashboardWidgetField?.type}`}
            type={selectedDashboardWidgetField?.type}
            title={selectedDashboardWidgetTitle}
            transparentBackground={false}
            dataId={WIDGET_PREVIEW_DATASTREAMS[0].id}
            dataPin={WIDGET_PREVIEW_DATASTREAMS[0].pin}
            decimals={0}
            position="relative"
            width={selectedDashboardWidgetSize.width}
            height={selectedDashboardWidgetSize.height}
            resize={false}
            resizeWidget={() => {}}
            draggable={false}
            extraProps={selectedDashboardWidgetProps}
            datastreams={WIDGET_PREVIEW_DATASTREAMS}
            preferDatastreamDefaultValue
          />
        </div>
      </aside>
    </div>
  </section>
);

export default DashboardWidgetsConfigPanel;
